



import gsap from "gsap";
import React, { useEffect, useRef } from "react";
// import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectCoverflow, Navigation } from 'swiper/modules';
import 'swiper/css/effect-coverflow';
// import { ScrollTrigger } from "gsap/ScrollTrigger";
import Zoom from "react-medium-image-zoom";

import Header from "../components/header";
import Footer from "../components/footer";
import Contact from '../components/contactform';
import Testimonials from "../components/testimonials";


import videos from "../assets/Biomeintro-Firstload.webm"
// import lazyvideo from "../assets/images/video-project-frame.mp4"
import preload from "../assets/Biome-intro.webp"
import walkvideos from "../assets/images/Walkthrough.m4v"

import nesting from "../assets/images/img/Homepage/nesting.png"
import fieldhouse from "../assets/images/Homepages/field-house.png"

import values from "../assets/images/Homepages/values.png"
import concept from "../assets/images/Homepages/CONCEPT.png"
import sustainable from "../assets/images/Homepages/SUSTAINABLE.png"

import conservation from "../assets/images/environment-protection.png"

import iconconservation01 from "../assets/images/img/Homepage/CONSERVATIONicons/Biodiversity-Conservation.png"
import iconconservation02 from "../assets/images/img/Homepage/CONSERVATIONicons/Climate-Resilience.png"
import iconconservation03 from "../assets/images/img/Homepage/CONSERVATIONicons/Economic-Viability.png"
import iconconservation04 from "../assets/images/img/Homepage/CONSERVATIONicons/SustainableYield.png"


import teeming from "../assets/images/Homepages/TEEMING-WITH-LIFE.png"
import EarthHolds from "../assets/images/biome-masterplan-gif.mov"



import image01 from "../assets/images/Homepages/Where-the-Earth-Holds-the-Blueprint-.png"

import ark from "../assets/images/Ark.webp"

import Living01 from "../assets/images/Parks-of-Serenity.webp"

import banners01 from "../assets/images/Hospitality/1.webp"
import banners02 from "../assets/images/Hospitality/2.webp"
import banners03 from "../assets/images/Hospitality/3.webp"

import club01 from "../assets/images/Homepages/Club-soluna.png"
import club02 from "../assets/images/Homepages/fitness.png"
import club03 from "../assets/images/Homepages/golf.png"
import club04 from "../assets/images/Homepages/library.png"




// import icon02 from "../assets/images/icons/club/2.webp"
// import icon03 from "../assets/images/icons/club/3.webp"
// import icon04 from "../assets/images/icons/club/4.webp"
import icon05 from "../assets/images/icons/club/5.webp"
import icon06 from "../assets/images/icons/club/6.webp"
// import icon08 from "../assets/images/icons/club/8.webp"
import icon09 from "../assets/images/icons/club/9.webp"
// import icon10 from "../assets/images/icons/club/10.webp"
// import icon11 from "../assets/images/icons/club/11.webp"
// import icon13 from "../assets/images/icons/club/13.webp"
import icon14 from "../assets/images/icons/club/14.webp"
import icon15 from "../assets/images/icons/club/15.webp"
import icon16 from "../assets/images/icons/club/16.webp"
import icon17 from "../assets/images/icons/club/17.webp"
import icon18 from "../assets/images/icons/club/18.webp"
// import icon19 from "../assets/images/icons/club/Destination-wedding.png"


import amenities01 from "../assets/images/amenities/1.png"
import amenities02 from "../assets/images/amenities/2.png"
import amenities03 from "../assets/images/amenities/3.png"
import amenities04 from "../assets/images/amenities/4.png"
import amenities05 from "../assets/images/amenities/5.png"


// Outdoors


import iconoutdoor03 from '../assets/images/icons/Outdoors/Adventure-Wall.webp'
import iconoutdoor04 from '../assets/images/icons/Outdoors/Barefoot-walkways.webp'
import iconoutdoor05 from '../assets/images/icons/Outdoors/Board-Walk.webp'
import iconoutdoor06 from '../assets/images/icons/Outdoors/Bonfire.webp'
import iconoutdoor07 from '../assets/images/icons/Outdoors/Cardio-space.webp'
import iconoutdoor08 from '../assets/images/icons/Outdoors/Hammock-Zone.webp'
import iconoutdoor09 from '../assets/images/icons/Outdoors/Interactive-Pavillion.webp'
import iconoutdoor10 from '../assets/images/icons/Outdoors/Jungle-Gym.webp'
// import iconoutdoor11 from '../assets/images/icons/Outdoors/PuttingLawn.webp'
// import iconoutdoor12 from '../assets/images/icons/Outdoors/Reflexology-Park.webp'
// import iconoutdoor13 from '../assets/images/icons/Outdoors/Sunken-Court.webp'
// import iconoutdoor15 from '../assets/images/icons/Outdoors/Therapeutic-garden.webp'
// import iconoutdoor16 from '../assets/images/icons/Outdoors/Yoga-space.webp'

// Community

import iconcommunity01 from '../assets/images/icons/Community/Community-Farming.webp' 
import iconcommunity02 from '../assets/images/icons/Community/Community-Lawn.webp' 
import iconcommunity03 from '../assets/images/icons/Community/Community-Orchard.webp' 
import iconcommunity04 from '../assets/images/icons/Community/Cultural-Zone.webp' 
import iconcommunity05 from '../assets/images/icons/Community/Leisure-Garden-Pavillion.webp' 
import iconcommunity06 from '../assets/images/icons/Community/Outdoor-Reading-Pods.webp' 
import iconcommunity07 from '../assets/images/icons/Community/Pet-Park.webp' 
import iconcommunity08 from '../assets/images/icons/Community/Seating-Decks.webp' 
// import iconcommunity09 from '../assets/images/icons/Community/Senior-Citizen-Park.webp' 
// import iconcommunity10 from '../assets/images/icons/Community/Sound-Park.webp'

// Wander
import iconwander01 from '../assets/images/icons/Wonderplay/Swings.png'
import iconwander02 from '../assets/images/icons/Wonderplay/Totlot.png'
import iconwander03 from '../assets/images/icons/Wonderplay/Sand-Pit.png'
import iconwander04 from '../assets/images/icons/Wonderplay/Slides.png'
import iconwander05 from '../assets/images/icons/Wonderplay/Tree-House.png'
import iconwander06 from '../assets/images/icons/Wonderplay/Play-Lawn.png'
import iconwander07 from '../assets/images/icons/Wonderplay/Play-Mound.png'

import amenitieswander01 from '../assets/images/icons/Wonderplay/image-2.png'
import amenitieswander02 from '../assets/images/icons/Wonderplay/image.png'

// Outdoors
import amenities06 from "../assets/images/icons/Outdoors/Outdoors-1.png"
import amenities07 from "../assets/images/icons/Outdoors/Outdoors-2.png"


// Community
import amenities08 from "../assets/images/icons/Community/Community-Space-1.webp"

// Caravan 

import amenities09 from "../assets/images/icons/Caravan/caravan-1.png"
import amenities10 from "../assets/images/icons/Caravan/caravan-2.png"

import map02 from "../assets/images/Image-2026-compressed.webp"

import future from "../assets/images/img/Homepage/FUTURE-GROWTH.png"

import livinglightly01 from "../assets/images/img/Homepage/living-lightly-togather/Farmhouse-Design-Construction.png"
import livinglightly02 from "../assets/images/img/Homepage/living-lightly-togather/Property-Management.png"
import livinglightly03 from "../assets/images/img/Homepage/living-lightly-togather/Rental-Management-Hospitality.png"
import livinglightly04 from "../assets/images/img/Homepage/living-lightly-togather/Home-Maintenance.png"
import livinglightly05 from "../assets/images/img/Homepage/living-lightly-togather/Housekeeping.png"
import livinglightly06 from "../assets/images/img/Homepage/living-lightly-togather/Plumbing-Electrical.png"
import livinglightly07 from "../assets/images/img/Homepage/living-lightly-togather/Farming-Gardening.png"
import livinglightly08 from "../assets/images/img/Homepage/living-lightly-togather/Security.png"


import gallery01 from "../assets/images/newimage/ongoingworks/1.png"
import gallery02 from "../assets/images/newimage/ongoingworks/2.png"
import gallery03 from "../assets/images/newimage/ongoingworks/3.png"
import gallery04 from "../assets/images/newimage/ongoingworks/4.png"
import gallery05 from "../assets/images/newimage/ongoingworks/5.png"
import gallery06 from "../assets/images/newimage/ongoingworks/6.png"

import hist01 from "../assets/images/12.png"
import hist02 from "../assets/images/13.png"
import hist03 from "../assets/images/14.png"

// gsap.registerPlugin(ScrollTrigger);

const gallerys = [
    {src:gallery01},
    {src:gallery02},
    {src:gallery03},
    {src:gallery04},
        {src:gallery05},
        {src:gallery06},
]





const banners = [
    {src:banners01},
    {src:banners02},
    {src:banners03},
]


const Clubsolunas = [
    {src:club01},
    {src:club02},
    {src:club03},
    {src:club04},
]



const  amenities = [
     {
        heading: 'Club Soluna',
        title: 'A Refuge Tailored to You, Shaped by Nature',
        summary: 'This is the heart of our community, a retreat woven into the earth’s quiet rhythm. A space where solitude and nature entwine, Club Soluna is your sanctuary for wellness, connection, and play.',
        banners: [
            amenities01,
            amenities02,
            amenities03,
            amenities04,
            amenities05,
        ],
        icons: [
                {
                src: icon17,
                title: "Wellness"
                },
                {
                src: icon06,
                title: "Fitness"
                },
                {
                src: icon05,
                title: "Dance Studio "
                },
                {
                src: icon15,
                title: "Table tennis "
                },
                {
                src: icon09,
                title: "Library "
                },
                {
                src: icon18,
                title: "Work Spaces "
                },
                {
                src: icon14,
                title: "Snooker "
                },
                {
                src: icon16,
                title: "Tennis "
                },
                // {
                // src: icon02,
                // title: "Amphitheater "
                // },
                // {
                // src: icon08,
                // title: "Kids Play Area "
                // },
                // {
                // src: icon03,
                // title: "Conference "
                // },
                // {
                // src: icon11,
                // title: "Mini Theater "
                // },
                // {
                // src: icon10,
                // title: "Mini Golf "
                // },
                // {
                // src: icon13,
                // title: "Retail Space "
                // },
                // {
                // src: icon04,
                // title: "Cricket Nets"
                // },

                //    {
                // src: icon19,
                // title: "Destination Wedding"
                // },


                ]
    },
     {
        heading: 'The Great Outdoors',
        title: 'Between SKY & SOIL',
        summary: 'A nature inspired retreat featuring  food forests, children’s play zones, hammock areas, bonfires, walking trails, and community farms all supported by eco friendly infrastructure fostering wellness, connection, and shared joy beyond walls.',
        banners: [
            amenities06,
            amenities07,
        ],
        icons: [
              

                {
                src:iconoutdoor03,
                title:'Adventure Wall'
                },
                {
                src:iconoutdoor04,
                title:'Barefoot walkways'
                },
                {
                src:iconoutdoor05,
                title:'Board Walk'
                },
                {
                src:iconoutdoor06,
                title:'Bonfire'
                },
                {
                src:iconoutdoor07,
                title:'Cardio space'
                },
                {
                src:iconoutdoor08,
                title:'Hammock Zone'
                },
                {
                src:iconoutdoor09,
                title:'Interactive Pavillion'
                },
                {
                src:iconoutdoor10,
                title:'Jungle Gym'
                },
                // {
                // src:iconoutdoor11,
                // title:'PuttingLawn'
                // },
                // {
                // src:iconoutdoor12,
                // title:'Reflexology Park'
                // },
                // {
                // src:iconoutdoor13,
                // title:'Sunken Court'
                // },
                // {
                // src:iconoutdoor15,
                // title:'Therapeutic garden'
                // },
                // {
                // src:iconoutdoor16,
                // title:'Yoga space'
                // },

                ]
    },
     {
        heading: 'Community Spaces',
        title: 'Huddle Feel the Warmth',
        summary: 'The community spaces at Biome  are designed for intimate gatherings and shared warmth. The sunken fire pit and social lawns create inviting environments where stories unfold under starlit skies, fostering belonging, connection, and timeless communal joy.',
        banners: [
            amenities08,
          
        ],
        icons: [
               
                {
                    src: iconcommunity01,
                    title: 'Community Farming'
                },     
                {
                    src: iconcommunity02,
                    title: 'Community Lawn'
                },     
                {
                    src: iconcommunity03,
                    title: 'Community Orchard'
                },     
                {
                    src: iconcommunity04,
                    title: 'Cultural Zone'
                },     
                {
                    src: iconcommunity05,
                    title: 'Leisure Garden Pavillion'
                },     
                {
                    src: iconcommunity06,
                    title: 'Outdoor Reading Pods'
                },     
                {
                    src: iconcommunity07,
                    title: 'Pet Park'
                },     
                {
                    src: iconcommunity08,
                    title: 'Seating Decks'
                },     
                // {
                //     src: iconcommunity09,
                //     title: 'Senior Citizen Park'
                // },     
                // {
                //     src: iconcommunity10,
                //     title: 'Sound Park'
                // },    


                ]
    },

     {
        heading: 'Wander, Wonder, Play',
        title: 'In Harmony With Nature',
        summary: 'The community spaces at Biome  are designed for intimate gatherings and shared warmth. The sunken fire pit and social lawns create inviting environments where stories unfold under starlit skies, fostering belonging, connection, and timeless communal joy.',
        banners: [
           amenitieswander01,
           amenitieswander02
          
        ],
        icons: [
               
                {
                    src: iconwander01,
                    title: 'Swings'
                },     
                {
                    src: iconwander02,
                    title: 'Totlot'
                },     
                {
                    src: iconwander03,
                    title: 'Sand Pit'
                },     
                {
                    src: iconwander04,
                    title: 'Slides'
                },     
                {
                    src: iconwander05,
                    title: 'Tree House'
                },     
                {
                    src: iconwander06,
                    title: 'Play Lawn'
                },     
                {
                    src: iconwander07,
                    title: 'Play Mound'
                }    
               


                ]
    },
     {
        heading: 'Caravan Park',
        title: 'A stay that grows where the forest breathes',
        summary: 'Biome  offers nature based amenities like a shaded living canopy, food forests, and peaceful nature spots. Infrastructure includes solar power, underground water, bio sanitation, 24/7 security, and shared spaces with bonfires, lawns, trails, and community farms.',
        banners: [
            amenities09,
            amenities10,
        ],
         icons: []
    }
]


const vision = [
      {
        heading: 'Cultivate',
        id: '5eddd9c',
        title: 'Our new age agroforestry project that combines the innovative principles of Syntropic Farming and the Miyawaki Method',
      },
      {
        heading: 'Conserve',
        id: 'dbbd088',
        title: 'The meticulous restoration of native flora and fauna is essential for ensuring a thriving, balanced ecosystem.',
      },
     
       {
        heading: 'Regenerate',
        id: 'cb27831',
        title: 'A harmonious blend of flora and fauna to transform into a thriving microcosm of ecological richness and vibrant biodiversity',
      },
         {
        heading: 'Foster Biodiversity',
        id: 'cb27831',
        class: 'Foster',
        title: 'Build diverse arid ecosystems using layered plants and staggered flowering to provide essential nectar and nesting for pollinators.',
      },
       {
        heading: 'Economic Viability',
        id: 'cb27831',
        class: 'Economic',
        title: 'Diversified income streams, reduced input costs, and long term sustainability leading to economic resilience.',
      },
    

      
]

const livinglightly = [
    {
        index:"dbbd088",
        id:"870ab2b",
       src:livinglightly01,
        value:"FarmhouseDesign",
        title:"Farmhouse Design"

    },
     {
        index:"5eddd9c",
        id:"f079dc5",
       src:livinglightly02,
        value:"PropertyManagement",
        title:"Property Management"

    },
     {
        index:"cb27831",
        id:"39dc98f",
        src:livinglightly03,
        value:"RentalManagement",
        title:"Hospitality"

    },
       {
        index:"dbbd088",
        id:"870ab2b",
       src:livinglightly04,
        value:"HomeMaintenance",
        title:"Home Maintenance"

    },
     {
        index:"5eddd9c",
        id:"f079dc5",
       src:livinglightly05,
        value:"Housekeeping",
        title:"Housekeeping"

    },
     {
        index:"cb27831",
        id:"39dc98f",
       src:livinglightly06,
        value:"Plumbing",
        title:"Plumbing & Electrical"

    },

       {
        index:"dbbd088",
        id:"870ab2b",
       src:livinglightly07,
        value:"FarmingGardening",
        title:"Farming & Gardening"

    },
     {
        index:"5eddd9c",
        id:"f079dc5",
       src:livinglightly08,
        value:"Security",
        title:"Security"

    },
    
]

const historic = [
    {
        src:hist01,
        title:"Historic Location",
        desc:"This region reflects a rich legacy of ancient civilizations, cultural continuity, and iconic monuments spanning centuries."
    },
     {
        src:hist02,
        title:"Spiritual Hub",
        desc:"A spiritual hub where diverse faiths flourish, ancient temples inspire, and sacred traditions nurture community devotion."
    },
     {
        src:hist03,
        title:"Industrial Ambition",
        desc:"Emerging as a dynamic industrial hub, the region fosters innovation, growth, and sustainable economic transformation"
    },

     {
        src:hist01,
        title:"Historic Location",
        desc:"This region reflects a rich legacy of ancient civilizations, cultural continuity, and iconic monuments spanning centuries."
    },
     {
        src:hist02,
        title:"Spiritual Hub",
        desc:"A spiritual hub where diverse faiths flourish, ancient temples inspire, and sacred traditions nurture community devotion."
    },
     {
        src:hist03,
        title:"Industrial Ambition",
        desc:"Emerging as a dynamic industrial hub, the region fosters innovation, growth, and sustainable economic transformation"
    },
    
]

export default function Home() {
// Video autoplay ----------------------------------------------->
 const videoRef = useRef(null);

  useEffect(() => {
    videoRef.current?.play().catch(console.error);
  }, []);


return(
<div className="dody-container">
    <Header />
    <section>

        <div className="biome biome-24">
            <div className='full-background-green videos-landing'>
                <div
                    className="biome-element biome-element-d2ebcd8 e-flex e-con-boxed e-con e-parent e-lazyloaded biome-kit-5-sticky">

                    <video ref={videoRef} className="image-full is--laptop biome-absolute-top biome-kit-5-sticky" autoPlay loop muted playsInline  poster={preload} preload="none">
                        <source src={videos} type='video/mp4' />
                    </video>

                </div>

                <div
                    className="biome-element biome-element-47b1a33 e-con-full e-flex e-con e-child biome-card-sticky biome-card-sticky-top ">
                    <img className="attachment-full size-full-flex attachment-full-bottom section-scroll-animation"
                        src={ark} alt={ark} />
                    <div className="e-con-inner text_center attr-text-white  section-scroll-animation">
                        <div
                            className="biome-element biome-element-0f1b0ec biome-widget biome-widget-heading animated fadeInUp  ">
                            <div className="biome-widget-container">
                                <h1 className="biome-heading-title biome-size-default animation__char_come  gsap-text  attr-text-white"
                                    data-anim="rotate">Come Home to the forest</h1>
                            </div>
                        </div>
                        <div
                            className="biome-element biome-element-e9056c4 biome-widget biome-widget-elementskit-heading animated fadeInUp">
                            <div className="biome-widget-container">
                                <div className="ekit-wid-con">
                                    <div
                                        className="ekit-heading elementskit-section-title-wraper  ekit_heading_tablet-   ekit_heading_mobile-">
                                        <h4 className="title-anim gsap-text  attr-text-white" data-anim="rotate">
                                            Future Proof Dream Farm Haven
                                        </h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                      
                        <div
                            className="biome-element biome-element-a8acb4f biome-widget biome-widget-text-editor animated fadeInUp">
                            <div className="biome-widget-container">
                                <p className='title-anim gsap-text text-center' data-anim="fade-up">
                                    Rooted in nature, powered by ingenuity. A sanctuary where dreams soar, convenience
                                    meets exclusivity, and simplicity dances with sophistication. Discover our luxury
                                    farm a glimpse into the future rooted in nature’s embrace.
                                </p>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div
                className="biome-element biome-element-9f59259 e-flex e-con-boxed e-con e-parent e-lazyloaded biome-kit-5-sticky">
                <div className="e-con-inner  section-scroll-animation">
                    <div
                        className="biome-element biome-element-809d30a e-con-full e-flex e-con e-child section-scroll-animation animate-section-trigger">

                        <div
                            className="biome-element biome-element-179e7f8 biome-widget biome-widget-heading animated fadeInUp ">
                            <div className="biome-widget-container">
                                <h2 data-anim="rotate"
                                    className="biome-heading-title attr-text-white biome-size-default animation__char_come  gsap-text">
                                    Integrating conservation, food production, and resilience via a holistic
                                    agroforestry approach.
                                </h2>
                            </div>
                        </div>

                        <div
                            className="biome-element biome-element-a35151e biome-widget biome-widget-text-editor animated fadeInUp">
                            <div className="biome-widget-container">
                                <p data-anim="fade-up" className='title-anim gsap-text attr-text-white text-center'>
                                    Envisioned as a bold and transformative answer to the trials of urban existence,
                                    Biome is a living symphony, a masterpiece where nature and purpose
                                    converge in perfect harmony. Destined to become the largest and most exquisitely
                                    planned agroforestry project, it seeks to weave sustainability, beauty, and
                                    innovation into a timeless response to the challenges of modern life. Rooted in the
                                    wisdom of syntropic farming and the Miyawaki method, this vision breathes life into
                                    the soil, nurturing a thriving ecosystem that regenerates itself with grace and
                                    abundance. It is a place where biodiversity flourishes, where forests rise like
                                    poetry written by the earth, and where humanity finds its rhythm alongside nature’s
                                    eternal song.</p>

                            </div>
                        </div>

                    </div>

                </div>
            </div>

            <div
                className="biome-element biome-element-8570b72 e-flex e-con-boxed e-con e-parent e-lazyloaded biome-kit-5-bg-white biome-kit-con-vission">
                <div className="e-con-inner section-scroll-animation  ">

                    <div
                        className="biome-element biome-element-47b1a33 e-con-full e-flex e-con e-child animate-section-trigger">

                        <div className="biome-element biome-element-0078ee0 e-con-full e-flex e-con e-child">
                            <div
                                className="biome-element biome-element-9e1a0ed e-con-full e-flex e-con e-child biome-element-cover-vision">
                                <div
                                    className="biome-element biome-element-43cdaa5 biome-widget biome-widget-text-editor animated fadeInUp">
                                    <div className="biome-widget-container">
                                        <h2 data-anim="rotate"
                                            className="ekit-heading--title elementskit-section-title animation__char_come  gsap-text">
                                            The Vision</h2>
                                        <h4 data-anim="rotate"
                                            className="ekit-heading--title elementskit-section-title animation__char_come  gsap-text">
                                            Sanctuaries of Holistic Agroforestry</h4>
                                        <p data-anim="fade-up" className='title-anim gsap-text'>
                                            To redefine the future of land by transforming it into a self-evolving, regenerative asset system.
                                            Transform agriculture with nature mimicking forest farming. Harmonize food
                                            production, conservation, resilience, and timeless sanctuaries. Restore
                                            ecosystems, boost biodiversity, and combat climate change in our sustainable
                                            farm future.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="biome-element biome-element-9e1a0ed e-con-full e-flex e-con e-child">
                                <div
                                    className="biome-element biome-element-43cdaa5 biome-widget biome-widget-text-editor animated fadeInUp">
                                    <div className="biome-widget-container">
                                        <h2 data-anim="rotate"
                                            className="ekit-heading--title elementskit-section-title animation__char_come  gsap-text ">
                                            The Mission</h2>
                                        <h4 data-anim="rotate"
                                            className="ekit-heading--title elementskit-section-title animation__char_come  gsap-text ">
                                           Reimagining Agriculture Cultivating Forest Farms for a Sustainable Future</h4>
                                        <p data-anim="fade-up" className='title-anim gsap-text '>
                                            To design and operate integrated ecosystems where land, living, and hospitality come together to create enduring ecological and financial value.
                                           Our Core Values include integrity, innovation, and community engagement, guiding all aspects of our operations and decision making process
                                        </p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div
                        className="biome-element biome-element-4de30bad e-grid e-con-full e-con e-child section-scroll-animation">
                        <div className="swiper-controls-icons swiper-controls"> <button
                                className="swiper-prev-icon"><svg xmlns="http://www.w3.org/2000/svg" width="16"
                                    height="16" fill="currentColor" class="bi bi-arrow-left" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd"
                                        d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8" />
                                </svg></button> <button className="swiper-next-icon"><svg
                                    xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                    class="bi bi-arrow-right" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd"
                                        d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                                </svg></button> </div>

                        <Swiper loop={true} autoplay={{
                    delay: 1000,
                    disableOnInteraction: false,
                }} allowTouchMove={true} navigation={{
                    prevEl: ".swiper-prev-icon",
                    nextEl: ".swiper-next-icon",
                }} modules={[Autoplay, Navigation]} spaceBetween={24} slidesPerView={3} breakpoints={{
                    0: {
                    slidesPerView: 1,   
                    spaceBetween: 12,
                    },
                    760: {
                    slidesPerView: 1, 
                    spaceBetween: 0,
                    },
                    1024: {
                    slidesPerView: 3,  
                    spaceBetween: 24,
                    },
                }}>
                            {vision.map((item, index) => (
                            <SwiperSlide>
                                <div className={`biome-element biome-element-${item.id} ${item.class} e-con-full e-flex
                                    e-con e-child`} kay={index}>
                                    <div
                                        className="biome-element biome-element-870ab2b biome-view-framed biome-position-right biome-mobile-position-right biome-shape-circle biome-widget biome-widget-icon-box">
                                        <div className="biome-widget-container">
                                            <div className="biome-icon-box-wrapper">
                                                <div className="biome-icon-box-content biome-card-sticky">
                                                    <h4 data-anim="rotate"
                                                        className="biome-icon-box-title animation__char_come  gsap-text ">
                                                        {item.heading}
                                                    </h4>

                                                    <p data-anim="fade-up" className="title-anim gsap-text ">
                                                        {item.title}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                            ))}
                        </Swiper>

                    </div>
                   <div className="section-scroll-animation">
<div className="biome-element biome-element-47b1a334 e-con-full e-flex e-con e-child biome-card-sticky animate-section-trigger">
  <div className="biome-element biome-element-0078ee0 e-con-full e-flex e-con e-child flex-values-box">
                                <div
                                    className="biome-element biome-element-179e7f8 biome-widget biome-widget-heading animated fadeInUp ">
                                    <div className="biome-widget--container">
                                        <img src={values} className="attachment-full size-full-flex" alt={values} />
                                    </div>
                                </div>

                                <div
                                    className="biome-element biome-element-a35151e biome-widget biome-widget-text-editor animated fadeInUp">
                                    <div className="biome-widget--container">
                                        <h2 data-anim="rotate"
                                            className="biome-heading-title biome-size-default animation__char_come gsap-text text-center">
                                            Values
                                        </h2>
                                        <h5 data-anim="fade-up" className='title-anim gsap-text text-center Jost--family '>
                                            Our core values include integrity, innovation, and community engagement,<br/> 
                                            Guiding all aspects of our operations and decision making processes.</h5>

                                    </div>
                                </div>
                            </div>

                    </div>
                    <div
                        className="biome-element biome-element-47b1a334 e-con-full e-flex e-con e-child biome-card-sticky animate-section-trigger">
                        <div className="e-con-inner biome-widget-container-cover-values">
                        
                            <div className="biome-element biome-element-0078ee0 e-con-full e-flex e-con e-child">
                                <div
                                    className="biome-element biome-element-179e7f8 biome-widget biome-widget-heading animated fadeInUp ">
                                    <div className="biome-widget-container">
                                        <img src={concept} className="attachment-full size-full-flex" alt={concept} />
                                    </div>
                                </div>

                                <div
                                    className="biome-element biome-element-a35151e biome-widget biome-widget-text-editor animated fadeInUp">
                                    <div className="biome-widget-container">
                                        <h3 data-anim="rotate"
                                            className="biome-icon-box-title title-anim gsap-text">
                                            Concept
                                        </h3>
                                        <p data-anim="fade-up" className='title-anim gsap-text'>
                                            Our concept where we envision a transformation in agriculture, one that harmonizes with nature, mimicking the structure and functions of natural forests. Our project aims to redefine conventional farming practices by transitioning towards forest farming, a sustainable approach that not only produces food but also restores ecosystems, enhances biodiversity, and mitigates climate change.
                                        </p>

                                    </div>
                                </div>
                            </div>

                            <div className="biome-element biome-element-0078ee0 e-con-full e-flex e-con e-child">
                                <div
                                    className="biome-element biome-element-179e7f8 biome-widget biome-widget-heading animated fadeInUp ">
                                    <div className="biome-widget-container">
                                        <img src={sustainable} className="attachment-full size-full-flex"
                                            alt={sustainable} />
                                    </div>
                                </div>

                                <div
                                    className="biome-element biome-element-a35151e biome-widget biome-widget-text-editor animated fadeInUp">
                                    <div className="biome-widget-container">
                                        <h3 data-anim="rotate"
                                            className="biome-icon-box-title title-anim gsap-text">
                                            Sustainable Practices
                                        </h3>
                                        <p data-anim="fade-up" className='title-anim gsap-text'>
                                            Despite the arid environment, aim to create a diverse ecosystem with multiple layers of vegetation, including canopy trees, shrubs, and ground cover plants. This diversity provides a variety of resources for pollinators, including nectar, pollen, and nesting sites. Encourage the establishment of a diverse plant community by selecting species with different flowering times, ensuring a continuous supply of floral resources throughout the growing season.
                                        </p>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            {/* biome-kit-5-height-full */}
                   </div>
                    

            <div
                class="biome-element biome-element-9f59259 e-flex e-con-boxed e-con e-parent e-lazyloaded biome-element-cover-craft">
                <div class="e-con-inner">
                    <div
                        class="biome-element biome-element-809d30a e-con-full e-flex e-con e-child section-scroll-animation">
                        <div class="biome-element biome-element-a86c8fe biome-widget biome-widget-image">
                            <div class="biome-widget-container">
                                <img loading="lazy" decoding="async" width="600" height="720" src={conservation}
                                    class="attachment-full size-full wp-image-137" alt={conservation} />
                            </div>
                        </div>
                        <div class="biome-element biome-element-179e7f8 biome-widget biome-widget-heading">
                            <div class="biome-widget-container">
                                <h2 class="biome-heading-title biome-size-default">CONSERVATION</h2>
                            </div>
                        </div>
                    
                        <div class="biome-element biome-element-d5f585c e-grid e-con-full e-con e-child">
                            <div class="biome-element biome-element-811c138 e-con-full e-flex e-con e-child">
                                <div
                                    class="biome-element biome-element-f24d034 biome-view-framed biome-position-inline-start biome-mobile-position-inline-start biome-shape-circle biome-widget biome-widget-icon-box">
                                    <div class="biome-widget-container">
                                        <div class="biome-icon-box-wrapper">

                                            <div class="biome-icon-box-icon">
                                                <span class="biome-icon">
                                                    <img src={iconconservation01}
                                                        className="attachment-full size-full-flex"
                                                        alt={iconconservation01} /> </span>
                                            </div>

                                            <div class="biome-icon-box-content">

                                                <h4 class="biome-icon-box-title text-center title-anim gsap-text">
                                                    <span>Biodiversity Conservation</span>
                                                </h4>

                                                <p class="biome-icon-box-description title-anim gsap-text text-center">
                                                    Creating habitats for diverse flora and fauna, promoting natural
                                                    pest control and pollination.</p>

                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="biome-element biome-element-e78d9d2 e-con-full e-flex e-con e-child">
                                <div
                                    class="biome-element biome-element-a222436 biome-view-framed biome-position-inline-start biome-mobile-position-inline-start biome-shape-circle biome-widget biome-widget-icon-box">
                                    <div class="biome-widget-container">
                                        <div class="biome-icon-box-wrapper">

                                            <div class="biome-icon-box-icon">
                                                <span class="biome-icon">
                                                    <img src={iconconservation02}
                                                        className="attachment-full size-full-flex"
                                                        alt={iconconservation02} /> </span>
                                            </div>

                                            <div class="biome-icon-box-content">

                                                <h4 class="biome-icon-box-title text-center title-anim gsap-text">
                                                    <span>Climate Resilience</span>
                                                </h4>

                                                <p class="biome-icon-box-description title-anim gsap-text text-center">
                                                    Carbon sequestration, soil conservation, and water retention,
                                                    contributing to climate change mitigation and adaptation.</p>

                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="biome-element biome-element-d98cf93 e-con-full e-flex e-con e-child">
                                <div
                                    class="biome-element biome-element-cefb276 biome-view-framed biome-position-inline-start biome-mobile-position-inline-start biome-shape-circle biome-widget biome-widget-icon-box">
                                    <div class="biome-widget-container">
                                        <div class="biome-icon-box-wrapper">

                                            <div class="biome-icon-box-icon">
                                                <span class="biome-icon">
                                                    <img src={iconconservation03}
                                                        className="attachment-full size-full-flex"
                                                        alt={iconconservation03} /> </span>
                                            </div>

                                            <div class="biome-icon-box-content">

                                                <h4 class="biome-icon-box-title text-center title-anim gsap-text">
                                                    <span>Economic Viability</span>
                                                </h4>

                                                <p class="biome-icon-box-description title-anim gsap-text text-center">
                                                    Diversified income streams, reduced input costs, and long term
                                                    sustainability leading to economic resilience for farm owners. </p>

                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="biome-element biome-element-750e22c e-con-full e-flex e-con e-child">
                                <div
                                    class="biome-element biome-element-64a0d9b biome-view-framed biome-position-inline-start biome-mobile-position-inline-start biome-shape-circle biome-widget biome-widget-icon-box">
                                    <div class="biome-widget-container">
                                        <div class="biome-icon-box-wrapper">

                                            <div class="biome-icon-box-icon">
                                                <span class="biome-icon">
                                                    <img src={iconconservation04}
                                                        className="attachment-full size-full-flex"
                                                        alt={iconconservation04} /> </span>
                                            </div>

                                            <div class="biome-icon-box-content">

                                                <h4 class="biome-icon-box-title text-center title-anim gsap-text">
                                                    <span>Sustainable Yield</span>
                                                </h4>

                                                <p class="biome-icon-box-description title-anim gsap-text text-center">
                                                    Enhanced productivity through agroforestry, with multiple crops
                                                    and products from the same land area. </p>

                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div
                className="biome-element biome-element-5c286c5 biome-element-5c286c5-flex e-flex e-con-boxed e-con e-parent e-lazyloaded">

                {/* Background Slideshow */}
                <div
                    className="biome-background-slideshow swiper swiper-fade swiper-horizontal swiper-pointer-events swiper-rtl swiper-watch-progress swiper-backface-hidden">
                    <div className="swiper-wrapper">
                        <div
                            className="biome-background-slideshow__slide swiper-slide swiper-slide-duplicate swiper-slide-duplicate-prev">
                            <div className="biome-background-slideshow__slide__image biome-ken-burns biome-ken-burns--in"
                                style={{
                backgroundImage:
                  `url('${future}')`,
              }} />
                        </div>
                    </div>
                    <span className="swiper-notification" />
                </div>

                {/* Content */}
                <div className="e-con-inner">
                    <div
                        className="biome-element biome-element-24d0812 biome-widget biome-widget-heading animated fadeInUp">
                        <div className="biome-widget-container">
                            <h2 className="biome-heading-title biome-size-default gsap-text attr-text-white">
                                Future Growth
                            </h2>
                        </div>

                    </div>

                    <div className="biome-element biome-element-b22c8d6 e-con-full e-flex e-con e-child">
                        <div
                            className="biome-element biome-element-2414686 biome-widget__width-initial biome-widget-mobile__width-inherit biome-widget biome-widget-text-editor animated fadeInUp">
                            <div className="biome-widget-container">
                                <p ata-anim="fade-up"
                                    className='title-anim gsap-text  biome-align-left biome-mobile-align-left attr-text-white'>
                                    Forest farming offers a paradigm shift in
                                    agriculture, integrating ecological principles with
                                    productive land use. By embracing this approach,
                                    we have the opportunity to not only feed the world
                                    sustainably but also regenerate ecosystems,
                                    empower communities, and safeguard our planet
                                    for future generations. Let us embark on this
                                    journey towards a greener, more resilient future
                                    together.
                                </p>
                            </div>
                        </div>

                        {/* <div
                            className="biome-element biome-element-0a4a386 biome-view-framed biome-widget__width-initial biome-widget-mobile__width-inherit biome-shape-circle biome-widget biome-widget-icon animated fadeInUp">
                            <div className="biome-widget-container">
                                <div className="biome-icon-wrapper">
                                    <a className="biome-icon" href="/fieldhouse">
                                        <i aria-hidden="true" className="icon icon-right-arrow"></i>
                                    </a>
                                </div>
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>

<div
                className="biome-element biome-element-8570b72 e-flex e-con-boxed e-con e-parent e-lazyloaded biome-kit-5-bg-white biome-fieldhouse section-scroll-animation">
                <a href="/architectural-consideration" target='_blank' className="e-con-inner animate-section-trigger">
                    <div className="biome-element biome-element-47b1a33 e-con-full e-flex e-con e-child ">
                      
                        <div
                            className="biome-element biome-element-e9056c4 biome-widget biome-widget-elementskit-heading animated fadeInUp">
                            <div className="biome-widget-container">
                                <div className="ekit-wid-con">
                                    <div
                                        className="ekit-heading elementskit-section-title-wraper text_left   ekit_heading_tablet-   ekit_heading_mobile-">
                                        <h2 data-anim="rotate"
                                            className="ekit-heading--title elementskit-section-title animation__char_come  gsap-text ">
                                            Architectural Harmony <span><span>Rooted in Memory, Shaped for
                                                    Tomorrow</span></span></h2>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="biome-element biome-element-0078ee0 e-con-full e-flex e-con e-child">
                            <div className="biome-element biome-element-9e1a0ed e-con-full e-flex e-con e-child">
                                <div
                                    className="biome-element biome-element-43cdaa5 biome-widget biome-widget-text-editor animated fadeInUp">
                                    <div className="biome-widget-container">
                                        <p data-anim="fade-up" className='title-anim gsap-text '>Drawing inspiration
                                            from the land’s memory, our architecture weaves local materials and thriving
                                            ecology into sanctuaries that nurture heritage, abundance, and living
                                            connection.</p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div className="biome-element biome-element-4de30ba e-grid e-con-full e-con e-child">
                        <div className="biome-element biome-element-dbbd088 e-con-full e-flex e-con e-child">
                            <div
                                className="biome-element biome-element-870ab2b biome-view-framed biome-position-right biome-mobile-position-right biome-shape-circle biome-widget biome-widget-icon-box">
                                <div className="biome-widget-container">
                                    <div className="biome-icon-box-wrapper">

                                        <div className="biome-icon-box-content biome-card-sticky">
                                            <h4 data-anim="rotate"
                                                className="biome-icon-box-title animation__char_come  gsap-text ">The
                                                Design
                                            </h4>
                                            <p data-anim="fade-up" className="title-anim gsap-text ">Local materials and
                                                ancient patterns, shaping structures that honor terrain’s natural
                                                contours, heritage, and enduring spirit.</p>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="biome-element biome-element-5eddd9c e-con-full e-flex e-con e-child">
                            <div
                                className="biome-element biome-element-f079dc5 biome-view-framed biome-position-right biome-mobile-position-right biome-shape-circle biome-widget biome-widget-icon-box">
                                <div className="biome-widget-container">
                                    <div className="biome-icon-box-wrapper">

                                        <div className="biome-icon-box-content biome-card-sticky">
                                            <h4 data-anim="rotate"
                                                className="biome-icon-box-title animation__char_come  gsap-text ">
                                                Landscape
                                            </h4>
                                            <p data-anim="fade-up" className="title-anim gsap-text ">Layered trees,
                                                shrubs, crops, and water channels unite landscape and
                                                architecture elements nurturing sustainability, heritage, and vibrancy.
                                            </p>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="biome-element biome-element-cb27831 e-con-full e-flex e-con e-child">
                            <div
                                className="biome-element biome-element-39dc98f biome-view-framed biome-position-right biome-mobile-position-right biome-shape-circle biome-widget biome-widget-icon-box">
                                <div className="biome-widget-container">
                                    <div className="biome-icon-box-wrapper">

                                        <div className="biome-icon-box-content biome-card-sticky">
                                            <h4 data-anim="rotate"
                                                className="biome-icon-box-title animation__char_come  gsap-text ">
                                                Conservation
                                            </h4>
                                            <p data-anim="fade-up" className="title-anim gsap-text ">Amidst arid breath,
                                                a tapestry of life blooms canopy arms, fragrant shrubs, and refuge for
                                                all wings and roots through every season.</p>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                </a>
            </div>


            
            <div
                className="biome-element biome-element-5c286c5 biome-element-5c286c5-flex e-flex e-con-boxed e-con e-parent e-lazyloaded first-story-section">

                {/* Background Slideshow */}
                <div
                    className="biome-background-slideshow swiper swiper-fade swiper-horizontal swiper-pointer-events swiper-rtl swiper-watch-progress swiper-backface-hidden">
                    <div className="swiper-wrapper">
                        <div
                            className="biome-background-slideshow__slide swiper-slide swiper-slide-duplicate swiper-slide-duplicate-prev">
                            <div className="biome-background-slideshow__slide__image biome-ken-burns biome-ken-burns--in"
                                style={{
                backgroundImage:
                  `url('${nesting}')`,
              }} />
                        </div>
                    </div>
                    <span className="swiper-notification" />
                </div>

                {/* Content */}
                <div className="e-con-inner">
                    <div
                        className="biome-element biome-element-24d0812 biome-widget biome-widget-heading animated fadeInUp">
                        <div className="biome-widget-container">
                            <h2 className="biome-heading-title biome-size-default gsap-text attr-text-white">
                                Nurturing Only
                            </h2>
                            <br/>
                            <br/>
                        </div>
                        <div
                            className="biome-element biome-element-2414686 biome-widget__width-initial biome-widget-mobile__width-inherit biome-widget biome-widget-text-editor animated fadeInUp">
                            <div className="biome-widget-container">
                                <p ata-anim="fade-up"
                                    className='title-anim gsap-text  biome-align-left biome-mobile-align-left attr-text-white'>
                                    This project spans 60 acres of stunning
                                    mango garden, beautifully surrounded
                                    by a serene lake and a flowing stream
                                    with picturesque mountain providing
                                    the perfect backdrop

                                </p>
                            </div>
                        </div>

                    </div>

                    <div className="biome-element biome-element-b22c8d6 e-con-full e-flex e-con e-child">
                        <div
                            className="biome-element biome-element-2414686 biome-widget__width-initial biome-widget-mobile__width-inherit biome-widget biome-widget-text-editor animated fadeInUp">
                            <div className="biome-widget-container">
                                <p ata-anim="fade-up"
                                    className='title-anim gsap-text  biome-align-left biome-mobile-align-left attr-text-white'>
                                    Our new age agroforestry project that
                                    combines the innovative principles of
                                    Syntropic Farming and the Miyawaki
                                    Method
                                </p>
                            </div>
                        </div>

                        {/* <div
                            className="biome-element biome-element-0a4a386 biome-view-framed biome-widget__width-initial biome-widget-mobile__width-inherit biome-shape-circle biome-widget biome-widget-icon animated fadeInUp">
                            <div className="biome-widget-container">
                                <div className="biome-icon-wrapper">
                                    <a className="biome-icon" href="#">
                                        <i aria-hidden="true" className="icon icon-right-arrow"></i>
                                    </a>
                                </div>
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>



            <div
                className="biome-element biome-element-5c286c5 e-flex e-con-boxed e-con e-parent e-lazyloaded first-story-section">

                <div className="e-con--inner">
                    <div
                        className="biome-element biome-element-47b1a33 e-con-full e-flex e-con e-child biome-card-sticky  biome-kit-5-bg-white animate-section-trigger">
                       
                        <div className="biome-element biome-element-0078ee0 e-con-full e-flex e-con e-child">
                            <div className="biome-element biome-element-9e1a0ed e-con-full e-flex e-con e-child">
                                <div
                                    className="biome-element biome-element-43cdaa5 biome-widget biome-widget-text-editor animated fadeInUp">
                                    <div className="biome-widget-container">
                                        <h2 data-anim="rotate"
                                            className="ekit-heading--title elementskit-section-title animation__char_come  gsap-text ">
                                            The Master Plan </h2>

                                    </div>
                                </div>
                            </div>
                            <div className="biome-element biome-element-027d233 e-con-full e-flex e-con e-child ">
                                <div
                                    className="biome-element biome-element-077f5f3 biome-align-right biome-mobile-align-right biome-widget biome-widget-button animated fadeInUp">
                                    <div className="biome-widget-container">
                                        {/* <img className="attachment-full size-full-flex" src={MASTERPlan}
                                            alt={MASTERPlan} /> */}
                                        <p data-anim="fade-up"
                                            className='title-anim gsap-text  biome-align-left biome-mobile-align-left'>
                                            Our 60 acre master plan is not an imposition on the land, it is woven into
                                            the wild. A central spine, reminiscent of Hampi's ancient bazaars, connects
                                            community zones, while quiet paths lead to private nestings. Every
                                            element from the Clubhouse and community farms to the streamside activities
                                            and paddy fields  is designed to nurture both land and people.</p>
                                        <div className="biome-button-wrapper"><a
                                                className="biome-button biome-button-link biome-size-sm"
                                                href="/masterplan" target='_blank'><span
                                                    className="biome-button-content-wrapper"><span
                                                        className="biome-button-icon fill-white-color"><i
                                                            aria-hidden="true"
                                                            className="icon icon-right-arrow"></i></span><span
                                                        className="biome-button-text animation__char_come  gsap-text ">Explore
                                                        the Master Plan</span></span></a></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="biome-element  e-con-full e-flex e-con e-child">
                            <div
                                className="biome-widget-container elementskit-section-title-wraper text_center biome-kit-5-height-full">
                                <a href="/masterplan" target='_blank'>
                                    <video className="image-full is--laptop biome-absolute-top biome-kit-5-sticky"
                                        autoPlay loop muted>
                                        <source src={EarthHolds} type='video/mp4' />
                                    </video>
                                </a>

                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <div
                className="biome-element biome-element-5c286c5 e-flex e-con-boxed e-con e-parent e-lazyloaded biome-kit-5-sticky section-scroll-animation">

                <a href="/fieldhouse" target='_blank' className="e-con-inner e-con-inner-width">
                    <div
                        className="biome-element biome-element-47b1a33 e-con-full e-flex e-con e-child biome-card-sticky animate-section-trigger">
                    
                        <div className="biome-element biome-element-0078ee0 e-con-full e-flex e-con e-child">
                            <div className="biome-element biome-element-9e1a0ed e-con-full e-flex e-con e-child">
                                <div
                                    className="biome-element biome-element-43cdaa5 biome-widget biome-widget-text-editor animated fadeInUp">
                                    <div className="biome-widget-container">
                                        <h2 data-anim="rotate"
                                            className="ekit-heading--title elementskit-section-title attr-text-white animation__char_come  gsap-text ">
                                           Vibrant Habitat teeming with life</h2>
                                    </div>
                                </div>
                            </div>
                            <div className="biome-element biome-element-027d233 e-con-full e-flex e-con e-child">
                                <div
                                    className="biome-element biome-element-077f5f3 biome-align-right biome-mobile-align-right biome-widget biome-widget-button animated fadeInUp">
                                    <div className="biome-widget-container">
                                        <p data-anim="fade-up"
                                            className="attr-text-white biome-align-left biome-mobile-align-left title-anim gsap-text ">
                                            It’s not just a place it’s a feeling, a quiet pull back to something ancient
                                            and true. Imagine waking to the golden hush of morning, where mist dances over tree tops and the
                                            air carries the scent of earth afterrain. Here, the whispers of the wind weave through the
                                            branches, telling stories older than time itself. Each breath is deep, pure, sweet with
                                            the essence of  nature’s untouched beauty. The world slows, the noise fades, and in its
                                            place, the rustling leaves, the murmuring stream, and the warmth of the sun become your only
                                            companions.This is where life moves to nature’s rhythm seamless, unhurried, infinite
                                        </p>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="biome-element  e-con-full e-flex e-con e-child first-story-section">
                            <div
                                className="biome-widget-container elementskit-section-title-wraper text_center biome-kit-5-height-full">
                                <img className="attachment-full size-full-flex" src={teeming} alt={teeming} />
                            </div>
                        </div>
                    </div>

                </a>
            </div>
            <div className="biome-element biome-element-5c286c5 e-flex e-con-boxed e-con e-parent e-lazyloaded">

                <a href='/fieldhouse' target='_blank' className="e-con--inner">
                    <div
                        className="biome-element biome-element-47b1a33 e-con-full e-flex e-con e-child biome-card-sticky biome-kit-5-bg-white">
                        <div className='section-scroll-animation animate-section-trigger'>
                            {/* <div
                                className="biome-element biome-element-0f1b0ec biome-widget biome-widget-heading animated fadeInUp">
                                <div className="biome-widget-container">
                                    <h6
                                        className="biome-heading-title biome-size-default animation__char_come  gsap-text ">
                                        Your Fieldhouse</h6>
                                </div>
                            </div> */}

                            <div className="biome-element biome-element-0078ee0 e-con-full e-flex e-con e-child">
                                <div className="biome-element biome-element-9e1a0ed e-con-full e-flex e-con e-child">
                                    <div
                                        className="biome-element biome-element-43cdaa5 biome-widget biome-widget-text-editor animated fadeInUp">
                                        <div className="biome-widget-container">
                                            <h2 data-anim="rotate"
                                                className="ekit-heading--title elementskit-section-title animation__char_come  gsap-text ">
                                                Your Fieldhouse: Crafted to Endure, Created to Belong
                                            </h2>

                                        </div>
                                    </div>
                                </div>
                                <div className="biome-element biome-element-027d233 e-con-full e-flex e-con e-child ">
                                    <div
                                        className="biome-element biome-element-077f5f3 biome-align-right biome-mobile-align-right biome-widget biome-widget-button animated fadeInUp">
                                        <div className="biome-widget-container">
                                            {/* <img className="attachment-full size-full-flex" src={MASTERPlan}
                                                alt={MASTERPlan} /> */}
                                            <p data-anim="fade-up"
                                                className='title-anim gsap-text  biome-align-left biome-mobile-align-left'>
                                                Your Fieldhouse is crafted from resilient, biophilic materials chosen
                                                not only for their strength and durability but for their natural harmony with the landscape. Designed
                                                without a traditional foundation, it rests lightly on the earth, allowing the terrain to
                                                breathe and ecosystems to thrive undisturbed.

                                            </p>
                                            <p data-anim="fade-up"
                                                className='title-anim gsap-text  biome-align-left biome-mobile-align-left'>
                                                This thoughtful approach to construction is both less invasive and more
                                                enduring. Natural materials reduce the need for ongoing maintenance while aging gracefully over
                                                time. The result is a home that requires little upkeep, lasts for generations, and quietly coexists with
                                                the wild surroundings offering a life that’s both rooted and free.
                                            </p>
                                            <div className="biome-button-wrapper">
                                                <div className="biome-button biome-button-link biome-size-sm"
                                                    href="/masterplan"><span className="biome-button-content-wrapper">
                                                        <span className="biome-button-icon"><i aria-hidden="true"
                                                                className="icon icon-right-arrow"></i></span>
                                                        <span
                                                            className="biome-button-text animation__char_come  gsap-text ">Explore
                                                            Fieldhouse</span></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="biome-element  e-con-full e-flex e-con e-child ">
                            <div
                                className="biome-widget-container elementskit-section-title-wraper text_center biome-kit-5-height-full">
                                <img className="attachment-full size-full-flex first-story-section" src={fieldhouse}
                                    alt={fieldhouse} />
                            </div>
                        </div>
                    </div>

                </a>
            </div>

            <div className="container-wrappers">
                <div className="biome biome-687">
                    <div
                        className="biome-element biome-element-4fcb1b1 e-flex e-con-boxed e-con e-parent e-lazyloaded horizontal-container-panel section-scroll-animation">

                        <div className="biome-background-slideshow ">
                            <Swiper loop={true} autoplay={{
                                        delay: 1000,
                                        disableOnInteraction: false,
                                        }} slidesPerView="auto" allowTouchMove={true} modules={[ Autoplay]}>
                                {Clubsolunas.map((Clubsoluna, i) => (
                                <SwiperSlide>
                                    <div className="biome-background-slideshow__slide">
                                        <div className="biome-background-slideshow__slide__image biome-ken-burns biome-ken-burns--in"
                                            style={{ backgroundImage: `url(${Clubsoluna.src})` }}>
                                        </div>
                                    </div>
                                </SwiperSlide>
                                ))}
                            </Swiper>

                        </div>

                        <div className="e-con-inner animate-section-trigger">
                            <div
                                className="biome-element biome-element-0e4df59 biome-widget biome-widget-heading animated fadeInUp">
                                <div className="biome-widget-container">
                                    <h2 data-anim="rotate" className="biome-heading-title gsap-text biome-size-default">
                                        Club Soluna. A Refuge Tailored to You, Shaped by Nature</h2>
                                </div>
                            </div>
                            <div className="biome-element biome-element-48776fe e-con-full e-flex e-con e-child"
                                data-id="48776fe" data-element_type="container">
                                <div
                                    className="biome-element biome-element-b750a21 biome-widget__width-initial biome-widget-mobile__width-inherit biome-widget biome-widget-text-editor animated fadeInUp">
                                    <div className="biome-widget-container">

                                        <p data-anim="fade-up" className='title-anim gsap-text attr-text-white'>
                                            This is the heart of our community, a retreat woven into the earth’s quiet
                                            rhythm. A space where solitude and nature entwine, Club Soluna is your
                                            sanctuary for wellness, connection, and play.
                                        </p>
                                    </div>
                                </div>
                                <div
                                    className="biome-element biome-element-65874f3 biome-view-framed biome-widget__width-initial biome-widget-mobile__width-inherit biome-shape-circle biome-widget biome-widget-icon animated fadeInUp">
                                    <div className="biome-widget-container">
                                        <div className="biome-icon-wrapper">
                                            <a className="biome-icon" href="/amenities">
                                                <i aria-hidden="true" className="icon icon-right-arrow"></i> </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>


            <div className='biome biome-687 biome-68712 unplug-container'>
                <div className="wrapper">

                    {amenities.map((item, i) => (
                    <div className="card-wrapper" key={i} id={i}>
                        <div className="card">
                            <div key={i}
                                className='biome-swiper-background-12 biome-swiper-background-12-amenities'>
                                <div
                                    className="e-con--inner biome-element biome-element-4cfa0db e-con-full e-flex e-con e-child">

                                    <div
                                        className="biome-element biome-element-e4064a3 e-con-full e-flex e-con e-child">
                                        <div
                                            className="biome-element biome-element-0f1b0ec biome-widget biome-widget-heading animated fadeInUp">
                                            <div className="biome-widget-container">
                                                <h6 data-anim="rotate"
                                                    className="biome-heading-title biome-size-default gsap-text Jost--family">The
                                                    Amenities </h6>
                                            </div>
                                        </div>
                                        <div
                                            className="biome-element biome-element-e9056c4 biome-widget biome-widget-elementskit-heading animated fadeInUp">
                                            <div className="biome-widget-container">
                                                <div className="ekit-wid-con">
                                                    <div
                                                        className="ekit-heading elementskit-section-title-wraper text_left   ekit_heading_tablet-   ekit_heading_mobile-">
                                                        <h2 data-anim="rotate"
                                                            className="ekit-heading--title elementskit-section-title gsap-text">
                                                            {item.heading}<br />{item.title}</h2>
                                                    </div>

                                                </div>

                                            </div>
                                        </div>
                                        <div
                                            className="biome-element biome-element-43cdaa5 biome-widget biome-widget-text-editor animated fadeInUp">
                                            <div className="biome-widget-container">
                                                <p data-anim="fade-up" className='title-anim gsap-text'>{item.summary}
                                                </p>
                                            </div>
                                        </div>
                                        {/* <div
                                            className="biome-element biome-element-027d233 e-con-full e-flex e-con e-child">
                                            <div
                                                className="biome-element biome-element-077f5f3 biome-align-left biome-mobile-align-left biome-widget biome-widget-button animated fadeInUp">
                                                <div className="biome-widget-container">
                                                    <div className="biome-button-wrapper">
                                                        <a href="/amenities" className="biome-button biome-button-link biome-size-sm">
                                                            <span className="biome-button-content-wrapper">
                                                                <span className="biome-button-icon">
                                                                    <i aria-hidden="true" className="icon icon-right-arrow"></i>
                                                                </span>
                                                                <span className="biome-button-text">Explore Our Amenities</span>
                                                            </span>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> */}
                                    </div>

                                    <div
                                        className="biome-element biome-element-49618f2 e-con-full e-flex e-con e-child">
                                        <div
                                            className="biome-element biome-element-2a39490 biome-widget biome-widget-image animated">
                                            <div className="biome-widget-container">

                                                <Swiper loop={true} autoplay={{
                                                    delay: 10000,
                                                    disableOnInteraction: false,
                                                    }} slidesPerView="auto" allowTouchMove={true} modules={[
                                                    Autoplay]}>
                                                    {item.banners.map((img, idx) => (
                                                    <SwiperSlide>
                                                        <img className="attachment-full size-full wp-image-122 wp-image-122 wp-image-122-radius-2"
                                                            alt={img} key={idx} sizes="(max-width: 800px) 100vw, 800px"
                                                            src={img} />
                                                    </SwiperSlide>
                                                    ))}
                                                </Swiper>

                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="biome biome-577">
                                    <div className="biome-grid biome-con-full biome-top-up">
                                        <div className="biome-row">
                                            {item.icons.map((icon, idx) => (
                                            <div className="biome-column biome-con-full biome-flex biome-child biome-grid-amenities"
                                                key={idx}>
                                                <div className="biome-widget biome-widget-image-box">
                                                    <div className="biome-widget-container">
                                                        <div className="biome-image-box-wrapper">
                                                            <figure className="biome-image-box-img biome-kit-aminities">
                                                                <img src={icon.src}
                                                                    sizes="(max-width: 294px) 100vw, 294px" width="294"
                                                                    height="294" decoding="async" alt={icon.title || ""
                                                                    } className="attachment-full size-full" />
                                                            </figure>
                                                            <div className="biome-image-box-content">
                                                                <h6 data-anim="rotate"
                                                                    className="biome-image-box-title gsap-text">
                                                                    {icon.title}</h6>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    ))}

                </div>

                <div className="container-wrappers  container-wrappers-slider">
                    <div
                        className="biome-element biome-element-4fcb1b1 e-flex e-con-boxed e-con e-parent e-lazyloaded horizontal-container-panel">

                        <div className="biome-background-slideshow">
                            <Swiper loop={true} autoplay={{
                                        delay: 1000,
                                        disableOnInteraction: false,
                                        }} slidesPerView="auto" allowTouchMove={true} modules={[ Autoplay]}>
                                {banners.map((banner, i) => (
                                <SwiperSlide>
                                    <div className="biome-background-slideshow__slide">
                                        <div className="biome-background-slideshow__slide__image biome-ken-burns biome-ken-burns--in"
                                            style={{ backgroundImage: `url(${banner.src})` }}>
                                        </div>
                                    </div>
                                </SwiperSlide>
                                ))}
                            </Swiper>

                        </div>

                        <div className="e-con-inner  animate-section-trigger">
                            <div
                                className="biome-element biome-element-0e4df59 biome-widget biome-widget-heading animated fadeInUp">
                                <div className="biome-widget-container">
                                    {/* <h1
                                        className="ekit-heading--title elementskit-section-title  animation__char_come gsap-text  attr-text-white">
                                        Biome Hospitality </h1> */}
                                    <h2 data-anim="rotate"
                                        className="biome-heading-title biome-size-default  animation__char_come gsap-text ">
                                        Unplug, Unwind, and Flow with Nature</h2>
                                </div>
                            </div>
                            <div className="biome-element biome-element-48776fe e-con-full e-flex e-con e-child">
                                <div
                                    className="biome-element biome-element-b750a21 biome-widget__width-initial biome-widget-mobile__width-inherit biome-widget biome-widget-text-editor animated fadeInUp">
                                    <div className="biome-widget-container">
                                        <p data-anim="fade-up" className='title-anim gsap-text attr-text-white'>
                                            Let the stream wrap around your senses
                                            cool waters lapping at your feet, the
                                            whisper of leaves in the breeze, and the
                                            soft hum of flowing time. Here, unplug,
                                            unwind, and flow where nature leads.
                                        </p>

                                    </div>
                                </div>
                                {/* <div
                                    className="biome-element biome-element-65874f3 biome-view-framed biome-widget__width-initial biome-widget-mobile__width-inherit biome-shape-circle biome-widget biome-widget-icon animated fadeInUp">
                                    <div className="biome-widget-container">
                                        <div className="biome-icon-wrapper">
                                            <a className="biome-icon" href="/biome-hospitality">
                                                <i aria-hidden="true" className="icon icon-right-arrow"></i> </a>
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>

                </div>

            </div>

            <div className='biome biome-687 biome-68712 unplug-container'>

                  <div className="horizontal-container">
                    <div className="horizontal-wrapper section-scroll-animation">
                        <div className="panel horizontal-canopy panel-canopy panel-canopy-widthmax">
                            <div
                                className="biome-element biome-element-4fcb1b1 e-flex e-con-boxed e-con e-parent e-lazyloaded section-scroll-animation horizontal-container-panel horizontal--panels">

                                <div className="biome-background-slideshow">

                                    <div className="biome-background-slideshow__slide">
                                        <div className="biome-background-slideshow__slide__image biome-ken-burns biome-ken-burns--in"
                                            style={{ backgroundImage: `url(${map02})` }}>
                                        </div>
                                    </div>

                                </div>
                                <div className="e-con--inner-panels  ">
                                    <div
                                        className="biome-element biome-element-0e4df59 biome-widget biome-widget-heading animated fadeInUp animate-section-trigger">
                                        <div className="biome-widget-container">
                                           
                                            <h2 data-anim="rotate"
                                                className="biome-heading-title biome-size-default  animation__char_come gsap-text ">
                                                Beneath the canopy's
                                            </h2>
                                        </div>
                                    </div>
                                    <div
                                        className="biome-element biome-element-48776fe e-con-full e-flex e-con e-child animate-section-trigger">
                                        <div
                                            className="biome-element biome-element-b750a21 biome-widget__width-initial biome-widget-mobile__width-inherit biome-widget biome-widget-text-editor animated fadeInUp">
                                            <div className="biome-widget-container">
                                                <p data-anim="fade-up" className='title-anim gsap-text attr-text-white'>
                                                    At Biome, every trail invites discovery, every tree shares ancient
                                                    stories, and every step sparks adventure. Winding paths dance through
                                                    untouched wonders, leading to our community's heart. A quiet spine
                                                    links to the clubhouse; lush canopies guard private retreats. Wander
                                                    here with unhurried footsteps and step on rustling fallen leaves as
                                                    nature’s symphony embraces you tightly in our eco sanctuary.
                                                </p>

                                            </div>
                                        </div>

                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>

                <div
                    className="biome-element biome-element-8570b72 e-flex e-con-boxed e-con e-parent e-lazyloaded biome-kit-5-bg-white section-scroll-animation living-lightly">
                    <div className="e-con--inner">
                        <div
                            className="biome-element biome-element-47b1a33 e-con-full e-flex e-con e-child animate-section-trigger">

                            <div
                                className="biome-element biome-element-e9056c4 biome-widget biome-widget-elementskit-heading animated fadeInUp">
                                <div className="biome-widget-container">
                                    <div className="ekit-wid-con">
                                        <div
                                            className="ekit-heading elementskit-section-title-wraper text_left   ekit_heading_tablet-   ekit_heading_mobile-">
                                            <h2 data-anim="rotate"
                                                className="ekit-heading--title elementskit-section-title animation__char_come  gsap-text ">
                                                Living Lightly, Together</h2>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="biome-element biome-element-0078ee0 e-con-full e-flex e-con e-child">
                                <div className="biome-element biome-element-9e1a0ed e-con-full e-flex e-con e-child">
                                    <div
                                        className="biome-element biome-element-43cdaa5 biome-widget biome-widget-text-editor animated fadeInUp">
                                        <div className="biome-widget-container">
                                            <p data-anim="fade-up" className='title-anim gsap-text '>
                                                A dedicated stewardship team nurtures every layer of life here from
                                                protecting the land and maintaining natural systems to cultivating regenerative farms
                                                and forest rooted infrastructure. This same collective also supports you with
                                                farmhouse design and construction, rental and hospitality management, and long term
                                                property care offering a seamless path to forest living. By sharing services and
                                                responsibilities, each nest becomes lighter to hold. Costs come down. Connection goes up.
                                            </p>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div
                            className="biome-element biome-element-4de30ba e-grid e-con-full e-con e-child section-scroll-animation">
                            {livinglightly.map((item, index) => (
                            <div className={`biome-element biome-element-center`} key={index} id={item.value}>
                                <div className={`biome-element biome-element-${item.id} biome-view-framed
                                    biome-position-center biome-widget-icon-box`}>
                                    <img src={item.src} className="attachment-full size-full-flex" alt={item.src} />
                                    <div className="biome-widget-container">

                                        <div className="biome-icon-box-wrapper">

                                            <div className="biome-icon-box-content biome-card-sticky">
                                                <h6 data-anim="rotate"
                                                    className="biome-icon-box-title animation__char_come  gsap-text ">
                                                    {item.title}</h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            ))}

                        </div>

                    </div>
                </div>

              
            </div>

            <div className="biome-element biome-element-5c286c5 e-flex e-con-boxed e-con e-parent e-lazyloaded ">
                <div className="e-con-inner">
                    <div
                        className="biome-element biome-element-47b1a33 e-con-full e-flex e-con e-child section-scroll-animation">
                        {/* <div
                            className="biome-element biome-element-0f1b0ec biome-widget biome-widget-heading animated fadeInUp e-con-full e-flex e-con e-child">
                            <div className="biome-widget-container">
                                <h6 className="biome-heading-title biome-size-default animation__char_come  gsap-text ">
                                    Living infrastructure of Biome</h6>
                            </div>
                        </div> */}

                        <div className="biome-element e-con-full e-flex e-con e-child  animate-section-trigger">
                            <div className="biome-element biome-widget biome-widget-text-editor animated fadeInUp">
                                <div className="biome-widget-container">

                                    <h2 data-anim="rotate"
                                        className="ekit-heading--title elementskit-section-title animation__char_come  gsap-text text-center">
                                        Where the Earth Holds the Blueprint
                                    </h2>
                                    <h2 data-anim="rotate"
                                        className="ekit-heading--title elementskit-section-title animation__char_come  gsap-text text-center">
                                            The Living Infrastructure of BIOME
                                    </h2>
                                    <p data-anim="fade-up"
                                        className='title-anim gsap-text text-center'>
                                        Here, nothing is just built, it is woven
                                        into the wild. Paths don’t just lead you
                                        forward, they lead you deeper into the
                                        rhythm of a land that listen 
                                    </p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div className="biome-element">
                <div
                    className="biome-widget-container elementskit-section-title-wraper text_center biome-kit-5-height-full">
                    <img className="attachment-full size-full wp-image-122 wp-image-blueprint" alt={image01}
                        sizes="(max-width: 800px) 100vw, 800px" src={image01} />
                    <div
                        class="biome-element  e-con-full e-flex e-con e-child container-e-childs  animate-section-trigger">
                        <div class="feature-box">
                            <div className='box-e-childs bdFadeUp'>
                                <h4 data-anim="rotate" className='gsap-text'>ROADS & PATHWAYS</h4>
                                <ul>
                                    <li data-anim="fade-up" className='gsap-text'>Smart, Sustainable, and Seamless</li>
                                    <li data-anim="fade-up" className='gsap-text'>Internal Roads 12m and 9m wide
                                        eco friendly driveways, lined with native landscaping and shaded pedestrian
                                        paths</li>
                                </ul>
                            </div>

                            <div className='box-e-childs bdFadeUp'>
                                <h4 data-anim="rotate" className='gsap-text'>ENERGY & POWER</h4>
                                <ul>
                                    <li data-anim="fade-up" className='gsap-text'>Solar powered fencing and lighting in
                                        common areas</li>
                                    <li data-anim="fade-up" className='gsap-text'>DG backup for essential services</li>
                                    <li data-anim="fade-up" className='gsap-text'>Electric lines with feeder pillar
                                        connections</li>
                                </ul>
                            </div>
                        </div>

                        <div class="feature-box">
                            <div className='box-e-childs bdFadeUp'>
                                <h4 data-anim="rotate" className='gsap-text'>WASTE MANAGEMENT</h4>
                                <ul>
                                    <li data-anim="fade-up" className='gsap-text'>Bio degradable waste treatment
                                        facility</li>
                                    <li data-anim="fade-up" className='gsap-text'>Composting systems integrated with
                                        landscape use</li>
                                </ul>
                            </div>

                            <div className='box-e-childs bdFadeUp'>
                                <h4 data-anim="rotate" className='gsap-text'>SECURITY & CONNECTIVITY</h4>
                                <ul>
                                    <li data-anim="fade-up" className='gsap-text'>24/7 surveillance with boom barriers
                                        and CCTV at all entry/exit points</li>
                                    <li data-anim="fade-up" className='gsap-text'>Perimeter fencing and bio fencing for
                                        privacy and safety</li>
                                </ul>
                            </div>
                        </div>

                        <div class="feature-box">
                            <div className='box-e-childs bdFadeUp'>
                                <h4 data-anim="rotate" className='gsap-text'>RAIN WATER</h4>
                                <ul>
                                    <li data-anim="fade-up" className='gsap-text'>Rainwater harvesting pits and
                                        irrigation networks</li>
                                </ul>
                            </div>

                            <div className='box-e-childs bdFadeUp'>
                                <h4 data-anim="rotate" className='gsap-text'>WATER SYSTEMS</h4>
                                <ul>
                                    <li data-anim="fade-up" className='gsap-text'>Underground piped water supply</li>
                                    <li data-anim="fade-up" className='gsap-text'>Stormwater management and gutter
                                        drains</li>
                                    <li data-anim="fade-up" className='gsap-text'>On site Bio Sanitary Pit</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

            </div>


            <div className='full-background-green videos-landing'>
                <div className="biome-element biome-element-d2ebcd8 e-flex e-con-boxed e-con e-parent e-lazyloaded biome-kit-5-sticky">
                    <video className="image-full is--laptop biome-absolute-top biome-kit-5-sticky" autoPlay loop muted>
                        <source src={walkvideos} type='video/mp4' />
                    </video>
                </div>
            </div>
               

             <div
                className="biome-element biome-element-8570b72 e-flex e-con-boxed e-con e-parent e-lazyloaded biome-kit-5-bg-white biome-location">
                <div className="e-con-inner animate-section-trigger">
                    <div className="biome-element biome-element-47b1a33 e-con-full e-flex e-con e-child">
                        {/* <div
                            className="biome-element biome-element-0f1b0ec biome-widget biome-widget-heading animated fadeInUp">
                            <div className="biome-widget-container">
                                <h6 data-anim="rotate"
                                    className="biome-heading-title biome-size-default  animation__char_come  gsap-text ">
                                    The Location </h6>
                            </div>
                        </div> */}

                        <div
                            className="biome-element biome-element-e9056c4 biome-widget biome-widget-elementskit-heading animated fadeInUp">
                            <div className="biome-widget-container">
                                <div className="ekit-wid-con">
                                    <div
                                        className="ekit-heading elementskit-section-title-wraper text_left   ekit_heading_tablet-   ekit_heading_mobile-">
                                        <h2 data-anim="rotate"
                                            className="ekit-heading--title elementskit-section-title  animation__char_come  gsap-text ">
                                            The Nexus of Heritage and Progress</h2>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="biome-element biome-element-0078ee0 e-con-full e-flex e-con e-child">
                            <div className="biome-element biome-element-9e1a0ed e-con-full e-flex e-con e-child">
                                <div
                                    className="biome-element biome-element-43cdaa5 biome-widget biome-widget-text-editor animated fadeInUp">
                                    <div className="biome-widget-container">
                                        <p data-anim="fade-up" className=" title-anim gsap-text ">
                                            BIOME blends Krishnadevaraya heritage, Puttaparthi
                                            spirituality, and industrial hubs. A perfect harmony of nature, history, and
                                            forward thinking farm living. Serene farm life sits a few steps away from
                                            KIA, Laurus Labs, and BEL. Progress meets peace.
                                        </p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div className="biome-element biome-element-4de30ba-grid">
        <div className="carousel-wrapper-historic is--desktop">
          <div className="swiper-controls-icons swiper-controls"> <button
                className="swiper-prev-icon"><svg xmlns="http://www.w3.org/2000/svg" width="16"
                    height="16" fill="currentColor" class="bi bi-arrow-left" viewBox="0 0 16 16">
                    <path fill-rule="evenodd"
                        d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8" />
                </svg></button> <button className="swiper-next-icon"><svg
                    xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-arrow-right" viewBox="0 0 16 16">
                    <path fill-rule="evenodd"
                        d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                </svg></button> 
            </div>
        <div className="swiper-container-historic ">
<Swiper 
            loop={true}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            effect={'coverflow'}
            grabCursor={true}
            centeredSlides={true}
            slidesPerView={'auto'}
            allowTouchMove={true} 
            // loopAdditionalSlides={3}
            initialSlide={0}
            navigation={{
            prevEl: ".swiper-prev-icon",
            nextEl: ".swiper-next-icon",
            }}  
            coverflowEffect={{
            rotate: 50,
            stretch: 0,
            depth: 100,
            modifier: 1,
            slideShadows: true,
            }}
            className="custom-swiper-historic "
            modules={[Autoplay, EffectCoverflow, Navigation]} 
            spaceBetween={24} 
                    breakpoints={{
                    0: {
                    slidesPerView: 1,   
                    spaceBetween: 12,
                    },
                    760: {
                    slidesPerView: 1, 
                    spaceBetween: 0,
                    },
                    1024: {
                    slidesPerView: 3,  
                    spaceBetween: 24,
                    },
                }}
                >
{historic.map((item, index) => (
    <SwiperSlide key={index}>
  <div className="biome-element biome-element-hist slide">
                            <div
                                className="biome-element biome-widget-icon-box">
                                <div className="biome-widget-container">
                                    <div className="biome-icon-box-wrapper">
                                        <img src={item.src} alt={item.src}/>
                                        <div className="biome-icon-box-content biome-card-sticky">
                                            <h4 data-anim="rotate"
                                                className="biome-icon-box-title animation__char_come  gsap-text ">
                                                {item.title}
                                            </h4>
                                            <p data-anim="fade-up" className="title-anim gsap-text ">
                                                {item.desc}
                                            </p>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
    </SwiperSlide>

    
             
                       ))}
    </Swiper>
        </div>
       
        
    </div>
                   
                       
                <div className="swiper-container-historic is--mobile">
              <div className="swiper-controls-icons swiper-controls"> <button
                className="swiper-prev-icon"><svg xmlns="http://www.w3.org/2000/svg" width="16"
                    height="16" fill="currentColor" class="bi bi-arrow-left" viewBox="0 0 16 16">
                    <path fill-rule="evenodd"
                        d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8" />
                </svg></button> <button className="swiper-next-icon"><svg
                    xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-arrow-right" viewBox="0 0 16 16">
                    <path fill-rule="evenodd"
                        d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                </svg></button> 
            </div>
             <Swiper loop={true} autoplay={{
                    delay: 10000,
                    disableOnInteraction: false,
                }} allowTouchMove={true} navigation={{
                    prevEl: ".swiper-prev-icon",
                    nextEl: ".swiper-next-icon",
                }} modules={[Autoplay, Navigation]} 
                
                breakpoints={{
                    0: {
                    slidesPerView: 1,   
                    spaceBetween: 0,
                    }
                }}>
                          {historic.map((item, index) => (
                            <SwiperSlide>
                                <div className={`biome-elements biome-element-hist-12 slide e-con e-child`} key={index}>
                                   <div className="biome-widget-container-12">
                                    <div className="biome-icon-box-wrapper-12">
                                        <img src={item.src} alt={item.src}/>
                                        <div className="biome-icon-box-contents">
                                            <h4
                                                className="biome-icon-box-title animation__char_come  gsap-text ">
                                                {item.title}
                                            </h4>
                                            <p className="title-anim gsap-text ">
                                                {item.desc}
                                            </p>
                                        </div>

                                    </div>
                                </div>
                                </div>
                            </SwiperSlide>
                            ))}
                        </Swiper>

        </div>
      
                     

                   
                      
                    </div>
                    <div className="biome-icon-box-content">
                        <h4 data-anim="rotate" className="biome-icon-box-title  title-anim gsap-text ">
                            BIOME  blends ancient heritage (Krishnadevaraya/Puttaparthi) with a new age
                            industrial corridor (KIA, Laurus Labs), fusing nature and progress.
                        </h4>
                    </div>

                </div>
            </div>

            <div className="biome-element biome-element-47b1a33 e-con-full e-flex e-con e-child biome-card-sticky">
                {/* biome-swiper-background-12-aminities */}
                {/* carousel-aminities-element */}
                <div className="e-con-inner">

                    <div className='biome-swiper-background-12 bdFadeUp'>
                        <div
                            className="e-con--inner biome-element biome-element-4cfa0db e-con-full e-flex e-con e-child">

                            <div
                                className="biome-element biome-element-e4064a3 e-con-full e-flex e-con e-child section-scroll-animation  animate-section-trigger">

                                <div
                                    className="biome-element biome-element-2a39490 biome-widget biome-widget-image animated ">
                                    <div className="biome-widget-container biome-kit-5-features position-design">
                                        <img className="attachment-full size-full wp-image-122" alt={Living01}
                                            sizes="(max-width: 800px) 100vw, 800px" src={Living01} />
                                    </div>
                                </div>

                            </div>

                            <div
                                className="biome-element biome-element-49618f2 e-con-full e-flex e-con e-child   animate-section-trigger">

                                <div className="biome biome-577">
                                    <div
                                        className="biome-element biome-element-e9056c4 biome-widget biome-widget-elementskit-heading animated fadeInUp">
                                        <div className="biome-widget-container">
                                            <div className="ekit-wid-con">
                                                <div
                                                    className="ekit-heading elementskit-section-title-wraper text_left   ekit_heading_tablet-   ekit_heading_mobile-">
                                                    <h3 data-anim="rotate"
                                                        className="ekit-heading--title elementskit-section-title attr-text-white biome-kit-5-features">
                                                        Designed for Life.
                                                    </h3>

                                                </div>

                                            </div>

                                        </div>
                                    </div>
                                    <div className="biome-widget-container">
                                        <p data-anim="fade-up" className='title-anim gsap-text  attr-text-white'>
                                            At BIOME, the land is not simply
                                            cultivated it is invited to return to
                                            itself. Across 60 acres of
                                            consciously planted forest and
                                            flowing water, we craft not a
                                            garden, but a wilderness in quiet
                                            renewal.
                                        </p>
                                    </div>

                                    <div className="biome-widget-container">

                                        <p data-anim="fade-up" className='title-anim gsap-text  attr-text-white'>
                                            A Tapestry of Life, Woven in Green
                                            Diverse native and naturalised
                                            species form a living mosaic of food,
                                            shelter, and safety. Trees that flower
                                            in cycles, shrubs that host nests,
                                            herbs that heal. Each species
                                            planted is an invitation for butterflies
                                            to dance, for bees to hum, for birds
                                            to pause in mid journey and call this
                                            place home. Water That Welcomes
                                            the Wild Streams that shimmer. Still
                                            ponds that mirror the sky
                                        </p>
                                        <p data-anim="fade-up" className='title-anim gsap-text  attr-text-white'>
                                            Water bodies are not ornamental
                                            they are lifelines, drawing in
                                            dragonflies, and migratory birds
                                            seeking rest. Where waterflows,
                                            life follows. Biodiversity by Design this is a
                                            landscape in motion an evolving
                                            ecology With time, the forest will
                                            thicken, the calls of new species
                                            will echo at dusk, and the soil will
                                            teem with unseen life. BIOME
                                            becomes more than habitat it
                                            becomes a living organism, where
                                            every element supports another in
                                            a quiet choreography of
                                            coexistence.
                                        </p>

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

           <div className="biome biome-687">
            <div
                className="biome-element biome-element-03b44c8 e-flex e-con-boxed e-con e-parent e-lazyloaded biome-kit-5-bg-white">
                <div className="e-con-inner">
                  
                    <div
                        className="biome-element biome-element-e67a910 biome-widget biome-widget-elementskit-heading animated fadeInUp">
                        <div className="biome-widget-containers">
                            <div className="ekit-wid-con">
                                <div
                                    className="ekit-heading elementskit-section-title-wraper text_left   ekit_heading_tablet-   ekit_heading_mobile-">
                                    <h2 data-anim="rotate" className='title-anim gsap-text'>
                                       Witness Biome in Action: Our Living Legacy
                                    </h2>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="biome-widget-container">
                        <p data-anim="fade-up" className='title-anim gsap-text'>
                           Dive into the heart of sustainable innovation with these snapshots from our Biome farm site. See the passion, progress, and partnerships shaping a greener tomorrow.
                        </p>

                    </div>

                    <div className="biome-element biome-element-7928e5d e-grid e-con-full e-con e-child ">

                        {gallerys.map((gallery, i) => (
                        <div class="biome-element biome-element-dac90f79">
                                <Zoom key={i}>
                                   <img decoding="async" width="960" height="640" src={gallery.src}
                                className="attachment-full size-full wp-image-729" alt={gallery.src} />
                                </Zoom>
                        
                        </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>

            <Testimonials />
            <Contact />
        </div>
    </section>
    <Footer />
</div>
)
}